import type { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';

import { CartWrapper } from './CartWrapper';
import { ProductPageApp } from './components/programmePage/ProductPageApp/ProductPageApp';
import { ProductPageNav } from './components/programmePage/ProductPageNav/ProductPageNav';
import StudySelector from './components/programmePage/StudySelector/StudySelector';
import type { ShoppingCartProviderProps } from './context/CartContext';
import type { ProductPageProviderProps } from './context/ProductPageContext';
import { ProductPageProvider } from './context/ProductPageContext';

type CartProps = Omit<ShoppingCartProviderProps, 'children'>;
type ProductProps = Omit<ProductPageProviderProps, 'children'>;

const render = (containerId: string, cartProps: CartProps, productProps: ProductProps, children: ReactNode) => {
    const container = document.getElementById(containerId);

    if (!container) {
        return null;
    }

    createRoot(container).render(
        <CartWrapper props={cartProps}>
            <ProductPageProvider {...productProps}>{children}</ProductPageProvider>
        </CartWrapper>,
    );
};

export const renderProductPageApp = (id: string, cartProps: CartProps, productProps: ProductProps) =>
    render(id, cartProps, productProps, <ProductPageApp />);

export const renderApplyNow = (id: string, cartProps: CartProps, productProps: ProductProps) =>
    render(id, cartProps, productProps, <StudySelector />);

export const renderProgrammeNav = (id: string, cartProps: CartProps, productProps: ProductProps) =>
    render(id, cartProps, productProps, <ProductPageNav />);
